import toastr from "toastr";
import { phoneNumberFormatter } from '../../phoneNumberFormatter.js'

const validateStepOne = () => {
  let isValid = true;
  const stepOneAttributesIds = [
    "user_natural_profile_attributes_first_name",
    "user_natural_profile_attributes_last_name",
    "user_natural_profile_attributes_primary_country",
    "phone_number_input"
  ]

  $(stepOneAttributesIds).each((_, el) => {
    if(document.getElementById(el).value === '') {
      isValid = false;
    }
  });

  if(isValid) {
    toggleStep();
  } else {
    toastr.error('Merci de bien vouloir compléter tous les champs');
  };
};

const toggleStep = () => {
  $('#signUpStepOne, #signUpStepTwo').toggleClass('d-none');
};

const togglePasswordVisibility = (e) => {
  let input = e.currentTarget.parentElement.getElementsByClassName('form-control');

  if(input[0].type == 'text') {
    input[0].type = 'password';
  } else {
    input[0].type = 'text';
  }

  e.currentTarget.querySelector('.show_eye').classList.toggle('d-none');
  e.currentTarget.querySelector('.hide_eye').classList.toggle('d-none');
};

$(document).ready(() => {
  $('#signUpContinue').on('click', validateStepOne);
  $('#signUpPrevious').on('click', validateStepOne);

  $('.password').on('click', (e) => {
    togglePasswordVisibility(e);
  });

  const $form = $('form#new_user');

  if ($form.length === 0 || $('#signUpStepOne').length === 0) {
    return;
  }

  const phoneNumberInput       = $form[0].querySelector("#phone_number_input");
  const phoneNumberErrorMessage = $form[0].querySelector("#phone_number_error_message");

  phoneNumberFormatter(phoneNumberInput, phoneNumberErrorMessage);
});
